/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Hazards-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 1/31/18
 * Copyright All Rights Reserved
 */

const googleMapURL = key => `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places`;

export default googleMapURL;



// WEBPACK FOOTER //
// ./js/components/pages/Inventory/InventoryMap/Map/googleMapURL.js